import { SvgIcon } from '@mui/material';
import { night, ocean } from 'assets/colors';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';


export default function Cube ({ primaryColor, secondaryColor, sx={}, className, id }) {
  const primaryColorSelected = sx.color ? sx.color : '#ACCAF7';

  const secondaryColorSelected = secondaryColor ? secondaryColor : alpha(ocean['900'], 0.5);

  return (
    <Box className={`${className ? className : ''}`} sx={sx} id={id}>
      <SvgIcon
        className={className}
        sx={{
          width: '100%',
          height: '100%'
        }}
        width="142"
        height="142"
        viewBox="0 0 142 142"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M70.5287 0L0 35.2644V105.793L70.5287 141.057V70.5287L141.057 35.2644L70.5287 0Z" fill={primaryColorSelected}/>
        <path d="M141.057 35.2644L70.5287 70.5287V141.057L141.058 105.793L141.057 35.2644Z" fill={primaryColorSelected}/>
        <path d="M70.5287 0L0 35.2644L70.5287 70.5287L141.057 35.2644L70.5287 0Z" fill="url(#paint0_linear_1482_8750)"/>
        <path d="M70.5287 141.058V70.5288L0 35.2644V105.793" fill="url(#paint1_linear_1482_8750)"/>
        <path d="M70.5288 141.058V70.5288L141.058 35.2644V105.793" fill="url(#paint2_linear_1482_8750)"/>
        <defs>
        <linearGradient id="paint0_linear_1482_8750" x1="70.5287" y1="0" x2="70.5287" y2="70.5287" gradientUnits="userSpaceOnUse">
        <stop stopColor={secondaryColorSelected}/>
        <stop offset="1" stopColor={primaryColorSelected} stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1482_8750" x1="-29.8793" y1="140.793" x2="103.121" y2="50.2932" gradientUnits="userSpaceOnUse">
        <stop stopColor={primaryColorSelected} stopOpacity="0"/>
        <stop offset="0.846805" stopColor={secondaryColorSelected}/>
        </linearGradient>
        <linearGradient id="paint2_linear_1482_8750" x1="148.741" y1="132.586" x2="96.7415" y2="42.0863" gradientUnits="userSpaceOnUse">
        <stop stopColor={primaryColorSelected} stopOpacity="0"/>
        <stop offset="1" stopColor={secondaryColorSelected}/>
        </linearGradient>
        </defs>
      </SvgIcon>
    </Box>
  );
}
